module.exports = __webpack_public_path__ + "img/once_es.8bb8373a.png";